import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ViewToggleOption } from "../card-types";

@Component({
  selector: "view-toggle",
  templateUrl: "./view-toggle.component.html",
  styleUrls: ["../../dashboard-section.scss", "../../dashboard-section-v2.scss"],
  styles: [":host { display: contents; }"],
})
export class ViewToggleComponent {
  // .view-toggle-v2 sizes its sliding pill at 50%, so exactly two options.
  @Input() options: ViewToggleOption[] = [];
  @Input() value: string;
  @Input() dimmed: boolean = false;
  @Output() valueChange = new EventEmitter<string>();

  get isRightActive(): boolean {
    let active = false;
    if (this.options.length > 1 && this.options[1].value === this.value) {
      active = true;
    }
    return active;
  }
}
